<template>
  <ValidationObserver
    v-slot="{handleSubmit}"
    ref="formObserver"
  >
    <b-modal
      id="linkModal"
      v-model="linkModal.show"
      title="Create Link"
      @show="beforeShow"
      @hidden="hideModal"
      @ok.prevent="handleSubmit(onSubmit)"
      @hide="beforeHide"
    >
      <content-spinner
        :show="linkModal.loading"
        text="Please wait..."
      />
      <b-form
        v-if="!linkModal.loading"
        @submit="handleSubmit(onSubmit)"
        @reset="handleSubmit(onReset)"
        @keydown.enter.prevent="handleSubmit(onSubmit)"
      >
        <input-widget
          :model="form"
          :field="fields.fromEntityId"
        />
        <input-widget
          :model="form"
          :field="fields.toEntityId"
        />
        <input-widget
          :model="form"
          :field="fields.alias"
        />
        <!--        <input-widget :model="form" :field="fields.tags"/>-->
      </b-form>
      <template #modal-footer="{ok, cancel}">
        <div class="d-flex justify-content-between align-items-center w-100">
          <b-form-checkbox v-model="addAnother">
            Add Another
          </b-form-checkbox>
          <div>
            <b-button
              variant="secondary"
              :disabled="linkModal.loading"
              class="mr-2"
              @click="cancel"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              :disabled="linkModal.loading"
              @click="ok"
            >
              OK
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../core/components/ContentSpinner';
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
import InputWidget from '../../core/components/complex-table/components/InputWidget';


const {mapState, mapActions} = createNamespacedHelpers('sunModel');
export default {
  name: 'LinkModal',
  components: {InputWidget, ContentSpinner, ValidationProvider, ValidationObserver},
  data() {
    return {
      form: {
        fromEntityId: '',
        toEntityId: '',
        alias: '',
      },
      addAnother: false,
      fields: {
        fromEntityId: {
          type: 'select',
          required: true,
          label: 'From Entity',
          name: 'fromEntityId',
          data: {
            options: [
              {text: 'Fact/Dimension', value: '', disabled: true},
            ],
          },
        },
        toEntityId: {
          type: 'select',
          required: true,
          label: 'To Entity',
          name: 'toEntityId',
          data: {
            options: [
              {text: 'Dimension', value: '', disabled: true},
            ],
          },
        },
        alias: {
          type: 'text',
          required: false,
          label: 'Alias',
          name: 'alias',
        },
        /*tags: {
          type: 'tags',
          required: false,
          label: 'Tags',
          name: 'tags'
        }*/
      },
    };
  },
  computed: {
    ...mapState(['linkModal', 'sunModel']),
  },
  methods: {
    ...mapActions(['hideLinkModal', 'createLink']),
    beforeHide(e) {
      if (this.linkModal.loading) {
        e.preventDefault();
        return false;
      }
    },
    hideModal() {
      this.resetData();
      this.hideLinkModal();
    },
    async onSubmit(e) {
      // e.preventDefault();
      const {success, body} = await this.createLink(this.form);
      if (success) {
        if (!this.addAnother) {
          this.hideLinkModal();
        }
        this.$toasted.success('Link saved successfully', {
          duration: TOASTER_DURATION,
        });
        this.resetData();
      } else {
        this.$toasted.error(body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
    },
    beforeShow() {
      this.form = {...this.linkModal.data};
      this.sunModel.originalData.facts.forEach(fact => {
        this.fields.fromEntityId.data.options.push({
          value: fact.entityId, text: fact.entityDisplayName,
        });
      });
      this.sunModel.originalData.dimensions.forEach(dimension => {
        this.fields.fromEntityId.data.options.push({
          value: dimension.entityId, text: dimension.entityDisplayName,
        });
        this.fields.toEntityId.data.options.push({
          value: dimension.entityId, text: dimension.entityDisplayName,
        });
      });
    },
    resetData() {
      this.form = {
        fromEntityId: '',
        toEntityId: '',
        alias: '',
      };
      this.addAnother = false;
      this.fields.fromEntityId.data.options = [
        {text: 'Fact/Dimension', value: '', disabled: true},
      ];
      this.fields.toEntityId.data.options = [
        {text: 'Dimension', value: '', disabled: true},
      ];
      this.form = {...this.linkModal.data};
      this.$refs.formObserver.reset();
    },
  },
};
</script>

<style lang="scss">
#linkModal {
  /deep/ .lobi-spinner {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 1;
  }
}
</style>